import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";

const LINKS = [
  { to: "/tentang", label: "Tentang" },
  { to: "/kepimpinan", label: "Kepimpinan" },
  { to: "/jurulatih", label: "Jurulatih" },
  { to: "/keahlian", label: "Keahlian" },
  { to: "/direktori", label: "Direktori" },
  { to: "/program", label: "Program" },
  { to: "/hubungi", label: "Hubungi" },
];

export function PublicFooter() {
  const [orgInfo, setOrgInfo] = useState({ contact_email: "bodyguardsarawak@gmail.com", contact_phone: "082-544018 / 019-8766656" });

  useEffect(() => {
    api.get("/public/org-info").then((r) => {
      setOrgInfo((prev) => ({
        contact_email: r.data.contact_email || prev.contact_email,
        contact_phone: r.data.contact_phone || prev.contact_phone,
      }));
    }).catch(() => {});
  }, []);

  return (
    <footer className="relative bg-piks-black text-white/70 no-print overflow-hidden" data-testid="public-footer">
      <div className="diagonal-accent absolute top-0 right-8 h-full opacity-50">
        <span />
        <span />
        <span />
      </div>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 grid grid-cols-1 md:grid-cols-4 gap-10 relative z-10">
        <div className="md:col-span-2">
          <div className="flex items-center gap-3 mb-4">
            <img src="/piks-logo.png?v=7" alt="Bodyguard Sarawak" className="h-11 w-11 object-contain" />
            <div>
              <div className="font-display text-white text-base font-extrabold tracking-wide">BODYGUARD SARAWAK</div>
              <div className="text-xs text-white/50">Persatuan Pengawal Peribadi Sarawak</div>
            </div>
          </div>
          <p className="text-xs text-piks-gold tracking-[0.25em] font-semibold mb-4">BERSATU • BERINTEGRITI • PROFESIONAL</p>
          <p className="text-sm text-white/50 max-w-sm leading-relaxed">
            Menyatukan pengawal peribadi profesional, memperkukuh standard industri dan membina komuniti perlindungan yang lebih dipercayai di Sarawak.
          </p>
        </div>
        <div>
          <h4 className="text-white text-xs font-semibold tracking-[0.2em] mb-4">PAUTAN PANTAS</h4>
          <ul className="space-y-2.5">
            {LINKS.map((l) => (
              <li key={l.to}>
                <Link to={l.to} className="text-sm text-white/60 hover:text-piks-gold transition-colors" data-testid={`footer-link-${l.label.toLowerCase().replace(/\s/g, "-")}`}>
                  {l.label}
                </Link>
              </li>
            ))}
          </ul>
        </div>
        <div>
          <h4 className="text-white text-xs font-semibold tracking-[0.2em] mb-4">AHLI</h4>
          <ul className="space-y-2.5 mb-6">
            <li><Link to="/login" className="text-sm text-white/60 hover:text-piks-gold transition-colors" data-testid="footer-link-log-masuk">Log Masuk</Link></li>
            <li><Link to="/semak" className="text-sm text-white/60 hover:text-piks-gold transition-colors" data-testid="footer-link-semak-ahli">Semak Ahli</Link></li>
          </ul>
          <h4 className="text-white text-xs font-semibold tracking-[0.2em] mb-3">HUBUNGI</h4>
          <ul className="space-y-2 text-sm text-white/60">
            <li data-testid="footer-contact-email">{orgInfo.contact_email}</li>
            <li data-testid="footer-contact-phone">{orgInfo.contact_phone}</li>
          </ul>
        </div>
      </div>
      <div className="gold-divider opacity-30 relative z-10" />
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6 flex flex-col sm:flex-row justify-between items-center gap-3 text-[11px] text-white/40 relative z-10">
        <p>© 2026 Persatuan Pengawal Peribadi Sarawak. Hak cipta terpelihara.</p>
        <p>BODYGUARD SARAWAK</p>
      </div>
    </footer>
  );
}
